import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  input: {
    width: 32,
    height: 32,
    textAlign: 'center',
  }
});

export default useStyles;
